import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@streamr/tv-ui';
import styled from 'styled-components';
import { UserService } from '../../services/user/UserService';
import { PeopleIcon } from './PeopleIcon';
/**
 * Button that displays the number of speakers and requests in the broadcast.
 * Only displayed in the /alpha app.
 */
export function PeopleButton({ onClick, active }) {
    const speakers = UserService.getOutput().useSpeakers();
    const incomingRequests = UserService.getOutput().useIncomingRequests();
    const outgoingRequests = UserService.getOutput().useOutgoingRequests();
    // Total count includes speakers + all requests
    const count = speakers.length + incomingRequests.length + outgoingRequests.length;
    return (_jsxs(StyledPeopleButton, { title: "People", onClick: onClick, "$active": active, children: [_jsx(PeopleIcon, {}), count > 0 && _jsx(Badge, { children: count })] }));
}
const StyledPeopleButton = styled(Button) `
    --Button_Width: 3rem;
    --Button_Height: 3rem;
    color: var(--tv-ui-color-3);
    position: relative;
    opacity: ${({ $active }) => ($active ? 1 : 0.7)};

    &:hover {
        opacity: 1;
    }
`;
const Badge = styled.div `
    position: absolute;
    top: 2px;
    right: 2px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 100px;
    min-width: 16px;
    height: 13px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 4px;
    font-family: 'Poppins', sans-serif;
    font-size: 11px;
    font-weight: 500;
    line-height: 18px;
    color: rgba(255, 255, 255, 0.96);
`;
